const ancestor = "社群";
const CommunityRouter = [
  /* 社群首页 */
  {
    path: "/community",
    name: "community",
    meta: { screen: false, title: "社群",keepAlive:true, ancestor },
    component: () => import("@/views/community/Index.vue"),
  },
  {
    path: "/community/create",
    name: "community-create",
    meta: { screen: false, title: "创建社群", ancestor },
    component: () => import("@/views/community/create/Index.vue"),
  },
  {
    path: "/community/edit/:id",
    name: "community-edit",
    meta: { screen: false, title: "编辑社群", ancestor },
    component: () => import("@/views/community/create/Index.vue"),
  },
  /* 社群详情 */
  {
    path: "/community/detail/:id",
    name: "community-detail",
    meta: { screen: false, title: "社群详情", ancestor },
    component: () => import("@/views/community/detail/Index.vue"),
  },
  {
    path: "/community/invite-land/:id",
    name: "community-invite-land",
    meta: { screen: false, title: "社群邀请", ancestor },
    component: () => import("@/views/community/inviteLand/Index.vue"),
  },
];
export default CommunityRouter;
